import styled from 'styled-components';

const FormContainerStyle = styled.div`
	--registerPopupErrorPanelSizes: var(--sp7x);
	--registerPopupErrorPanelMarginRight: var(--sp4x);
	--registerPopupCloseIconSize: var(--sp3x);
	--registerPopupGlobalErrorPadding: var(--sp7x);

	.global-error {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: var(--registerPopupGlobalErrorPadding);
		border: 1px solid var(--errorColor);
		background-color: var(--secondaryColor1);

		.error-message {
			margin-bottom: var(--sp0-5x);
		}

		.error-panel {
			display: flex;
			justify-content: center;
			align-items: center;
			min-width: var(--registerPopupErrorPanelSizes);
			min-height: var(--registerPopupErrorPanelSizes);
			background-color: var(--errorColor);
			margin-right: var(--registerPopupErrorPanelMarginRight);
			clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);

			.global-error-close-icon {
				color: var(--primaryColor3);
				font-size: var(--registerPopupCloseIconSize);
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--registerPopupErrorPanelSizes: var(--sp7x);
		--registerPopupErrorPanelMarginRight: var(--sp3x);
		--registerPopupCloseIconSize: var(--sp3x);
		--registerPopupGlobalErrorPadding: var(--sp6x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--registerPopupErrorPanelSizes: var(--sp5x);
		--registerPopupErrorPanelMarginRight: var(--sp3x);
		--registerPopupCloseIconSize: var(--sp2x);
		--registerPopupGlobalErrorPadding: var(--sp6x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--registerPopupErrorPanelSizes: var(--sp5x);
		--registerPopupErrorPanelMarginRight: var(--sp3x);
		--registerPopupCloseIconSize: var(--sp2x);
		--registerPopupGlobalErrorPadding: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--registerPopupErrorPanelSizes: var(--sp5x);
		--registerPopupErrorPanelMarginRight: var(--sp3x);
		--registerPopupCloseIconSize: var(--sp2x);
		--registerPopupGlobalErrorPadding: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--registerPopupErrorPanelSizes: var(--sp5x);
		--registerPopupErrorPanelMarginRight: var(--sp2x);
		--registerPopupCloseIconSize: var(--sp2x);
		--registerPopupGlobalErrorPadding: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--registerPopupErrorPanelSizes: var(--sp5x);
		--registerPopupErrorPanelMarginRight: var(--sp2x);
		--registerPopupCloseIconSize: var(--sp2x);
		--registerPopupGlobalErrorPadding: var(--sp4x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--registerPopupErrorPanelSizes: var(--sp5x);
		--registerPopupErrorPanelMarginRight: var(--sp2x);
		--registerPopupCloseIconSize: var(--sp2x);
		--registerPopupGlobalErrorPadding: var(--sp4x);
	}
`;

export default FormContainerStyle;
